export default "__VITE_ASSET__h0zzeJEF__"